
const Definition = {

    id: "waterway",
    plan_level: 3,
    name: "WaterWay",
    path: "host/waterway/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/minimal-white-background_23-2148868062.jpg",
    colors: {
        background: "#ffffff",
        background_alt: "#f2f2f2",
        surface_dark: "#000000",
        header_background: "#ffffff",
        text: "#000000",
        text_soft: "#000000b3",
        text_muted: "#a1a1a1",
        text_inverse: "#ffffff",
        border: "#e5e5e5",
        primary: "#000000",
        on_primary: "#ffffff",
        success: "#22C55E",
        danger: "#EF4444"
    }

};

export default Definition;
